import { IMAGE_OPTIMIZATION_CDN_URL } from "../ExlyImage/constants/ExlyImage.constants";

export const ARROW_IMG_SRC = `${IMAGE_OPTIMIZATION_CDN_URL}/misc/next_arrow.svg`;
